var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.75C5.85 21.75 1.25 17.15 1.25 11.5C1.25 5.85 5.85 1.25 11.5 1.25C17.15 1.25 21.75 5.85 21.75 11.5C21.75 17.15 17.15 21.75 11.5 21.75ZM11.5 2.75C6.67 2.75 2.75 6.68 2.75 11.5C2.75 16.32 6.67 20.25 11.5 20.25C16.33 20.25 20.25 16.32 20.25 11.5C20.25 6.68 16.33 2.75 11.5 2.75Z",
    fill: "#60656C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9995 22.75C21.8095 22.75 21.6195 22.68 21.4695 22.53L19.4695 20.53C19.1795 20.24 19.1795 19.76 19.4695 19.47C19.7595 19.18 20.2395 19.18 20.5295 19.47L22.5295 21.47C22.8195 21.76 22.8195 22.24 22.5295 22.53C22.3795 22.68 22.1895 22.75 21.9995 22.75Z",
    fill: "#60656C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMember);
export default __webpack_public_path__ + "static/media/search_member.86616190dcd3451b24484a904b722f73.svg";
export { ForwardRef as ReactComponent };